export * from './move-display.component';
export * from './move-display.module';
